// Cover-mapping helpers — same aspect-fit logic as the mosaic renderer so
// halftone dots sample the same region of the source image.

export interface CoverMapping {
  readonly uScale: number;
  readonly vScale: number;
  readonly uOffset: number;
  readonly vOffset: number;
}

export function computeCoverMapping(
  canvasW: number,
  canvasH: number,
  sampleW: number,
  sampleH: number,
  cropAnchorX: number,
  cropAnchorY: number,
): CoverMapping {
  const canvasAspect = canvasW / canvasH;
  const imgAspect = sampleW / sampleH;
  let uScale = 1;
  let vScale = 1;
  let uOffset = 0;
  let vOffset = 0;
  if (imgAspect > canvasAspect) {
    uScale = canvasAspect / imgAspect;
    uOffset = (1 - uScale) * cropAnchorX;
  } else if (imgAspect < canvasAspect) {
    vScale = imgAspect / canvasAspect;
    vOffset = (1 - vScale) * cropAnchorY;
  }
  return { uScale, vScale, uOffset, vOffset };
}

/** Map a canvas pixel to normalised image UV (0..1). */
export function canvasToImageUv(
  x: number,
  y: number,
  canvasW: number,
  canvasH: number,
  map: CoverMapping,
): { readonly u: number; readonly v: number } {
  const uCanvas = x / canvasW;
  const vCanvas = y / canvasH;
  return {
    u: map.uOffset + uCanvas * map.uScale,
    v: map.vOffset + vCanvas * map.vScale,
  };
}
